import { render } from "./ChatHistory.vue?vue&type=template&id=1f1df154&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=1f1df154&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f1df154"

export default script